import _slicedToArray from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { css as t } from "styled-components";
var o = function o(_o) {
  return t(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @supports not (aspect-ratio: auto) {\n    &::before {\n      float: left;\n      padding-top: ", ";\n      content: '';\n    }\n    &::after {\n      display: block;\n      content: '';\n      clear: both;\n    }\n  }\n"])), function (t) {
    var _t$replace$split$map = t.replace(":", "/").split("/").map(function (t) {
        return parseInt(t.trim(), 10);
      }),
      _t$replace$split$map2 = _slicedToArray(_t$replace$split$map, 2),
      o = _t$replace$split$map2[0],
      n = _t$replace$split$map2[1];
    return "".concat((n / o * 100).toFixed(2), "%");
  }(_o));
};
export { o as default };